module.exports = __webpack_public_path__ + "files/ee4f625122f1109999bf4411a0a197c3.png";